import React from 'react'
import AutofillButton from 'src/participantHistory/autofill/AutofillButton'
import useAutofillIntakeNote from './useAutofillIntakeNote'

type Props = Omit<React.ComponentProps<typeof AutofillButton>, 'onAutofill'>

export default function AutofillIntakeNoteButton(props: Props) {
  const autofillIntakeNote = useAutofillIntakeNote()

  return <AutofillButton onAutofill={autofillIntakeNote} {...props} />
}
